/**
 * @otplib/core
 *
 * @author Gerald Yeo <contact@fusedthought.com>
 * @version: 12.0.1
 * @license: MIT
 **/
'use strict';

var _slicedToArray = require("/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _inherits = require("/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var _objectSpread = require("/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread2");

var _classCallCheck = require("/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, '__esModule', {
  value: true
});

function objectValues(value) {
  return Object.keys(value).map(function (key) {
    return value[key];
  });
}

(function (HashAlgorithms) {
  HashAlgorithms["SHA1"] = "sha1";
  HashAlgorithms["SHA256"] = "sha256";
  HashAlgorithms["SHA512"] = "sha512";
})(exports.HashAlgorithms || (exports.HashAlgorithms = {}));

var HASH_ALGORITHMS = objectValues(exports.HashAlgorithms);

(function (KeyEncodings) {
  KeyEncodings["ASCII"] = "ascii";
  KeyEncodings["BASE64"] = "base64";
  KeyEncodings["HEX"] = "hex";
  KeyEncodings["LATIN1"] = "latin1";
  KeyEncodings["UTF8"] = "utf8";
})(exports.KeyEncodings || (exports.KeyEncodings = {}));

var KEY_ENCODINGS = objectValues(exports.KeyEncodings);

(function (Strategy) {
  Strategy["HOTP"] = "hotp";
  Strategy["TOTP"] = "totp";
})(exports.Strategy || (exports.Strategy = {}));

var STRATEGY = objectValues(exports.Strategy);

var createDigestPlaceholder = function createDigestPlaceholder() {
  throw new Error('Please provide an options.createDigest implementation.');
};

function isTokenValid(value) {
  return /^(\d+)$/.test(value);
}

function padStart(value, maxLength, fillString) {
  if (value.length >= maxLength) {
    return value;
  }

  var padding = Array(maxLength + 1).join(fillString);
  return "".concat(padding).concat(value).slice(-1 * maxLength);
}

function keyuri(options) {
  var tmpl = "otpauth://".concat(options.type, "/{labelPrefix}:{accountName}?secret={secret}{query}");
  var params = [];

  if (STRATEGY.indexOf(options.type) < 0) {
    throw new Error("Expecting options.type to be one of ".concat(STRATEGY.join(', '), ". Received ").concat(options.type, "."));
  }

  if (options.type === 'hotp') {
    if (options.counter == null || typeof options.counter !== 'number') {
      throw new Error('Expecting options.counter to be a number when options.type is "hotp".');
    }

    params.push("&counter=".concat(options.counter));
  }

  if (options.type === 'totp' && options.step) {
    params.push("&period=".concat(options.step));
  }

  if (options.digits) {
    params.push("&digits=".concat(options.digits));
  }

  if (options.algorithm) {
    params.push("&algorithm=".concat(options.algorithm.toUpperCase()));
  }

  if (options.issuer) {
    params.push("&issuer=".concat(encodeURIComponent(options.issuer)));
  }

  return tmpl.replace('{labelPrefix}', encodeURIComponent(options.issuer || options.accountName)).replace('{accountName}', encodeURIComponent(options.accountName)).replace('{secret}', options.secret).replace('{query}', params.join(''));
}

var OTP = /*#__PURE__*/function () {
  function OTP() {
    var defaultOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, OTP);

    this._defaultOptions = Object.freeze(_objectSpread({}, defaultOptions));
    this._options = Object.freeze({});
  }

  _createClass(OTP, [{
    key: "create",
    value: function create() {
      var defaultOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return new OTP(defaultOptions);
    }
  }, {
    key: "clone",
    value: function clone() {
      var defaultOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var instance = this.create(_objectSpread(_objectSpread({}, this._defaultOptions), defaultOptions));
      instance.options = this._options;
      return instance;
    }
  }, {
    key: "allOptions",
    value: function allOptions() {
      return this.options;
    }
  }, {
    key: "resetOptions",
    value: function resetOptions() {
      this._options = Object.freeze({});
    }
  }, {
    key: "options",
    get: function get() {
      return Object.freeze(_objectSpread(_objectSpread({}, this._defaultOptions), this._options));
    },
    set: function set(options) {
      this._options = Object.freeze(_objectSpread(_objectSpread({}, this._options), options));
    }
  }]);

  return OTP;
}();

function hotpOptionsValidator(options) {
  if (typeof options.createDigest !== 'function') {
    throw new Error('Expecting options.createDigest to be a function.');
  }

  if (typeof options.createHmacKey !== 'function') {
    throw new Error('Expecting options.createHmacKey to be a function.');
  }

  if (typeof options.digits !== 'number') {
    throw new Error('Expecting options.digits to be a number.');
  }

  if (!options.algorithm || HASH_ALGORITHMS.indexOf(options.algorithm) < 0) {
    throw new Error("Expecting options.algorithm to be one of ".concat(HASH_ALGORITHMS.join(', '), ". Received ").concat(options.algorithm, "."));
  }

  if (!options.encoding || KEY_ENCODINGS.indexOf(options.encoding) < 0) {
    throw new Error("Expecting options.encoding to be one of ".concat(KEY_ENCODINGS.join(', '), ". Received ").concat(options.encoding, "."));
  }
}

var hotpCreateHmacKey = function hotpCreateHmacKey(algorithm, secret, encoding) {
  return Buffer.from(secret, encoding).toString('hex');
};

function hotpDefaultOptions() {
  var options = {
    algorithm: exports.HashAlgorithms.SHA1,
    createHmacKey: hotpCreateHmacKey,
    createDigest: createDigestPlaceholder,
    digits: 6,
    encoding: exports.KeyEncodings.ASCII
  };
  return options;
}

function hotpOptions(opt) {
  var options = _objectSpread(_objectSpread({}, hotpDefaultOptions()), opt);

  hotpOptionsValidator(options);
  return Object.freeze(options);
}

function hotpCounter(counter) {
  var hexCounter = counter.toString(16);
  return padStart(hexCounter, 16, '0');
}

function hotpDigestToToken(hexDigest, digits) {
  var digest = Buffer.from(hexDigest, 'hex');
  var offset = digest[digest.length - 1] & 0xf;
  var binary = (digest[offset] & 0x7f) << 24 | (digest[offset + 1] & 0xff) << 16 | (digest[offset + 2] & 0xff) << 8 | digest[offset + 3] & 0xff;
  var token = binary % Math.pow(10, digits);
  return padStart(String(token), digits, '0');
}

function hotpDigest(secret, counter, options) {
  var hexCounter = hotpCounter(counter);
  var hmacKey = options.createHmacKey(options.algorithm, secret, options.encoding);
  return options.createDigest(options.algorithm, hmacKey, hexCounter);
}

function hotpToken(secret, counter, options) {
  var hexDigest = options.digest || hotpDigest(secret, counter, options);
  return hotpDigestToToken(hexDigest, options.digits);
}

function hotpCheck(token, secret, counter, options) {
  if (!isTokenValid(token)) {
    return false;
  }

  var systemToken = hotpToken(secret, counter, options);
  return token === systemToken;
}

function hotpKeyuri(accountName, issuer, secret, counter, options) {
  return keyuri({
    algorithm: options.algorithm,
    digits: options.digits,
    type: exports.Strategy.HOTP,
    accountName: accountName,
    counter: counter,
    issuer: issuer,
    secret: secret
  });
}

var HOTP = /*#__PURE__*/function (_OTP) {
  _inherits(HOTP, _OTP);

  var _super = _createSuper(HOTP);

  function HOTP() {
    _classCallCheck(this, HOTP);

    return _super.apply(this, arguments);
  }

  _createClass(HOTP, [{
    key: "create",
    value: function create() {
      var defaultOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return new HOTP(defaultOptions);
    }
  }, {
    key: "allOptions",
    value: function allOptions() {
      return hotpOptions(this.options);
    }
  }, {
    key: "generate",
    value: function generate(secret, counter) {
      return hotpToken(secret, counter, this.allOptions());
    }
  }, {
    key: "check",
    value: function check(token, secret, counter) {
      return hotpCheck(token, secret, counter, this.allOptions());
    }
  }, {
    key: "verify",
    value: function verify(opts) {
      if (typeof opts !== 'object') {
        throw new Error('Expecting argument 0 of verify to be an object');
      }

      return this.check(opts.token, opts.secret, opts.counter);
    }
  }, {
    key: "keyuri",
    value: function keyuri(accountName, issuer, secret, counter) {
      return hotpKeyuri(accountName, issuer, secret, counter, this.allOptions());
    }
  }]);

  return HOTP;
}(OTP);

function parseWindowBounds(win) {
  if (typeof win === 'number') {
    return [Math.abs(win), Math.abs(win)];
  }

  if (Array.isArray(win)) {
    var _win = _slicedToArray(win, 2),
        past = _win[0],
        future = _win[1];

    if (typeof past === 'number' && typeof future === 'number') {
      return [Math.abs(past), Math.abs(future)];
    }
  }

  throw new Error('Expecting options.window to be an number or [number, number].');
}

function totpOptionsValidator(options) {
  hotpOptionsValidator(options);
  parseWindowBounds(options.window);

  if (typeof options.epoch !== 'number') {
    throw new Error('Expecting options.epoch to be a number.');
  }

  if (typeof options.step !== 'number') {
    throw new Error('Expecting options.step to be a number.');
  }
}

var totpPadSecret = function totpPadSecret(secret, encoding, minLength) {
  var currentLength = secret.length;
  var hexSecret = Buffer.from(secret, encoding).toString('hex');

  if (currentLength < minLength) {
    var newSecret = new Array(minLength - currentLength + 1).join(hexSecret);
    return Buffer.from(newSecret, 'hex').slice(0, minLength).toString('hex');
  }

  return hexSecret;
};

var totpCreateHmacKey = function totpCreateHmacKey(algorithm, secret, encoding) {
  switch (algorithm) {
    case exports.HashAlgorithms.SHA1:
      return totpPadSecret(secret, encoding, 20);

    case exports.HashAlgorithms.SHA256:
      return totpPadSecret(secret, encoding, 32);

    case exports.HashAlgorithms.SHA512:
      return totpPadSecret(secret, encoding, 64);

    default:
      throw new Error("Expecting algorithm to be one of ".concat(HASH_ALGORITHMS.join(', '), ". Received ").concat(algorithm, "."));
  }
};

function totpDefaultOptions() {
  var options = {
    algorithm: exports.HashAlgorithms.SHA1,
    createDigest: createDigestPlaceholder,
    createHmacKey: totpCreateHmacKey,
    digits: 6,
    encoding: exports.KeyEncodings.ASCII,
    epoch: Date.now(),
    step: 30,
    window: 0
  };
  return options;
}

function totpOptions(opt) {
  var options = _objectSpread(_objectSpread({}, totpDefaultOptions()), opt);

  totpOptionsValidator(options);
  return Object.freeze(options);
}

function totpCounter(epoch, step) {
  return Math.floor(epoch / step / 1000);
}

function totpToken(secret, options) {
  var counter = totpCounter(options.epoch, options.step);
  return hotpToken(secret, counter, options);
}

function totpEpochsInWindow(epoch, direction, deltaPerEpoch, numOfEpoches) {
  var result = [];

  if (numOfEpoches === 0) {
    return result;
  }

  for (var i = 1; i <= numOfEpoches; i++) {
    var delta = direction * i * deltaPerEpoch;
    result.push(epoch + delta);
  }

  return result;
}

function totpEpochAvailable(epoch, step, win) {
  var bounds = parseWindowBounds(win);
  var delta = step * 1000;
  return {
    current: epoch,
    past: totpEpochsInWindow(epoch, -1, delta, bounds[0]),
    future: totpEpochsInWindow(epoch, 1, delta, bounds[1])
  };
}

function totpCheck(token, secret, options) {
  if (!isTokenValid(token)) {
    return false;
  }

  var systemToken = totpToken(secret, options);
  return token === systemToken;
}

function totpCheckByEpoch(epochs, token, secret, options) {
  var position = null;
  epochs.some(function (epoch, idx) {
    if (totpCheck(token, secret, _objectSpread(_objectSpread({}, options), {}, {
      epoch: epoch
    }))) {
      position = idx + 1;
      return true;
    }

    return false;
  });
  return position;
}

function totpCheckWithWindow(token, secret, options) {
  if (totpCheck(token, secret, options)) {
    return 0;
  }

  var epochs = totpEpochAvailable(options.epoch, options.step, options.window);
  var backward = totpCheckByEpoch(epochs.past, token, secret, options);

  if (backward !== null) {
    return backward * -1;
  }

  return totpCheckByEpoch(epochs.future, token, secret, options);
}

function totpTimeUsed(epoch, step) {
  return Math.floor(epoch / 1000) % step;
}

function totpTimeRemaining(epoch, step) {
  return step - totpTimeUsed(epoch, step);
}

function totpKeyuri(accountName, issuer, secret, options) {
  return keyuri({
    algorithm: options.algorithm,
    digits: options.digits,
    step: options.step,
    type: exports.Strategy.TOTP,
    accountName: accountName,
    issuer: issuer,
    secret: secret
  });
}

var TOTP = /*#__PURE__*/function (_HOTP) {
  _inherits(TOTP, _HOTP);

  var _super2 = _createSuper(TOTP);

  function TOTP() {
    _classCallCheck(this, TOTP);

    return _super2.apply(this, arguments);
  }

  _createClass(TOTP, [{
    key: "create",
    value: function create() {
      var defaultOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return new TOTP(defaultOptions);
    }
  }, {
    key: "allOptions",
    value: function allOptions() {
      return totpOptions(this.options);
    }
  }, {
    key: "generate",
    value: function generate(secret) {
      return totpToken(secret, this.allOptions());
    }
  }, {
    key: "checkDelta",
    value: function checkDelta(token, secret) {
      return totpCheckWithWindow(token, secret, this.allOptions());
    }
  }, {
    key: "check",
    value: function check(token, secret) {
      var delta = this.checkDelta(token, secret);
      return typeof delta === 'number';
    }
  }, {
    key: "verify",
    value: function verify(opts) {
      if (typeof opts !== 'object') {
        throw new Error('Expecting argument 0 of verify to be an object');
      }

      return this.check(opts.token, opts.secret);
    }
  }, {
    key: "timeRemaining",
    value: function timeRemaining() {
      var options = this.allOptions();
      return totpTimeRemaining(options.epoch, options.step);
    }
  }, {
    key: "timeUsed",
    value: function timeUsed() {
      var options = this.allOptions();
      return totpTimeUsed(options.epoch, options.step);
    }
  }, {
    key: "keyuri",
    value: function keyuri(accountName, issuer, secret) {
      return totpKeyuri(accountName, issuer, secret, this.allOptions());
    }
  }]);

  return TOTP;
}(HOTP);

function authenticatorOptionValidator(options) {
  totpOptionsValidator(options);

  if (typeof options.keyDecoder !== 'function') {
    throw new Error('Expecting options.keyDecoder to be a function.');
  }

  if (options.keyEncoder && typeof options.keyEncoder !== 'function') {
    throw new Error('Expecting options.keyEncoder to be a function.');
  }
}

function authenticatorDefaultOptions() {
  var options = {
    algorithm: exports.HashAlgorithms.SHA1,
    createDigest: createDigestPlaceholder,
    createHmacKey: totpCreateHmacKey,
    digits: 6,
    encoding: exports.KeyEncodings.HEX,
    epoch: Date.now(),
    step: 30,
    window: 0
  };
  return options;
}

function authenticatorOptions(opt) {
  var options = _objectSpread(_objectSpread({}, authenticatorDefaultOptions()), opt);

  authenticatorOptionValidator(options);
  return Object.freeze(options);
}

function authenticatorEncoder(secret, options) {
  return options.keyEncoder(secret, options.encoding);
}

function authenticatorDecoder(secret, options) {
  return options.keyDecoder(secret, options.encoding);
}

function authenticatorGenerateSecret(numberOfBytes, options) {
  var key = options.createRandomBytes(numberOfBytes, options.encoding);
  return authenticatorEncoder(key, options);
}

function authenticatorToken(secret, options) {
  return totpToken(authenticatorDecoder(secret, options), options);
}

function authenticatorCheckWithWindow(token, secret, options) {
  return totpCheckWithWindow(token, authenticatorDecoder(secret, options), options);
}

var Authenticator = /*#__PURE__*/function (_TOTP) {
  _inherits(Authenticator, _TOTP);

  var _super3 = _createSuper(Authenticator);

  function Authenticator() {
    _classCallCheck(this, Authenticator);

    return _super3.apply(this, arguments);
  }

  _createClass(Authenticator, [{
    key: "create",
    value: function create() {
      var defaultOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return new Authenticator(defaultOptions);
    }
  }, {
    key: "allOptions",
    value: function allOptions() {
      return authenticatorOptions(this.options);
    }
  }, {
    key: "generate",
    value: function generate(secret) {
      return authenticatorToken(secret, this.allOptions());
    }
  }, {
    key: "checkDelta",
    value: function checkDelta(token, secret) {
      return authenticatorCheckWithWindow(token, secret, this.allOptions());
    }
  }, {
    key: "encode",
    value: function encode(secret) {
      return authenticatorEncoder(secret, this.allOptions());
    }
  }, {
    key: "decode",
    value: function decode(secret) {
      return authenticatorDecoder(secret, this.allOptions());
    }
  }, {
    key: "generateSecret",
    value: function generateSecret() {
      var numberOfBytes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
      return authenticatorGenerateSecret(numberOfBytes, this.allOptions());
    }
  }]);

  return Authenticator;
}(TOTP);

exports.Authenticator = Authenticator;
exports.HASH_ALGORITHMS = HASH_ALGORITHMS;
exports.HOTP = HOTP;
exports.KEY_ENCODINGS = KEY_ENCODINGS;
exports.OTP = OTP;
exports.STRATEGY = STRATEGY;
exports.TOTP = TOTP;
exports.authenticatorCheckWithWindow = authenticatorCheckWithWindow;
exports.authenticatorDecoder = authenticatorDecoder;
exports.authenticatorDefaultOptions = authenticatorDefaultOptions;
exports.authenticatorEncoder = authenticatorEncoder;
exports.authenticatorGenerateSecret = authenticatorGenerateSecret;
exports.authenticatorOptionValidator = authenticatorOptionValidator;
exports.authenticatorOptions = authenticatorOptions;
exports.authenticatorToken = authenticatorToken;
exports.createDigestPlaceholder = createDigestPlaceholder;
exports.hotpCheck = hotpCheck;
exports.hotpCounter = hotpCounter;
exports.hotpCreateHmacKey = hotpCreateHmacKey;
exports.hotpDefaultOptions = hotpDefaultOptions;
exports.hotpDigestToToken = hotpDigestToToken;
exports.hotpKeyuri = hotpKeyuri;
exports.hotpOptions = hotpOptions;
exports.hotpOptionsValidator = hotpOptionsValidator;
exports.hotpToken = hotpToken;
exports.isTokenValid = isTokenValid;
exports.keyuri = keyuri;
exports.objectValues = objectValues;
exports.padStart = padStart;
exports.totpCheck = totpCheck;
exports.totpCheckByEpoch = totpCheckByEpoch;
exports.totpCheckWithWindow = totpCheckWithWindow;
exports.totpCounter = totpCounter;
exports.totpCreateHmacKey = totpCreateHmacKey;
exports.totpDefaultOptions = totpDefaultOptions;
exports.totpEpochAvailable = totpEpochAvailable;
exports.totpKeyuri = totpKeyuri;
exports.totpOptions = totpOptions;
exports.totpOptionsValidator = totpOptionsValidator;
exports.totpPadSecret = totpPadSecret;
exports.totpTimeRemaining = totpTimeRemaining;
exports.totpTimeUsed = totpTimeUsed;
exports.totpToken = totpToken;